var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode.toUpperCase() != 'APP')?_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('h1',[_vm._v(_vm._s(_vm.raiseScreenTitle))])])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }